import { StructureEditorLazyLoadConfig } from '@Pages/StructureEditor/StructureEditorConstants';

function injectJs(src) {
  const script = document.createElement('script');
  script.src = src;
  if (!document.querySelector(`script[src="${src}"]`)) {
    document.head.appendChild(script);
    return new Promise((resolve, reject) => {
      script.onload = resolve;
      script.onerror = reject;
    });
  }
  return Promise.resolve();
}

function injectCss(href) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  if (!document.querySelector(`link[href="${href}"]`)) {
    document.head.appendChild(link);
    return new Promise((resolve, reject) => {
      link.onload = resolve;
      link.onerror = reject;
    });
  }
  return Promise.resolve();
}

export default function injectScripts() {
  return Promise.all([
    injectJs(StructureEditorLazyLoadConfig.cores.chemdraw[0]), // chemdrawweb.js
    injectCss(StructureEditorLazyLoadConfig.cores.chemdraw[1]), // bootstrap3-compatibility.css
  ]);
}
